module.exports = __webpack_public_path__ + "303cbd10d17e81fc48c145099aeafc43.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/LC.svg
// module id = 0EKn
// module chunks = 0